<template>
    <section class="my-4 mx-4">
        <h3 class="p-4 text-lg font-bold">Enter the code to unlock lifetime membership</h3>
        <div class="bg-gray-light py-4 px-8 rounded flex items-center">
            <div class="w-full">
                <input type="text" name="code" id="code" class="my-1 border border-gray-dark border-b-2 p-2 rounded w-full" placeholder="Paste your lifetime access code here" v-model="code">
                <p class="text-destructive" v-if="errors['code'] && errors['code'].length > 0">{{ errors['code'][0] }}</p>
                <button
                    class="mt-2 py-2 px-4 rounded-md bg-primary-lighter text-primary font-bold"
                    :loading="false"
                    :state="'...'"
                    @click="unlock"
                >
                    <strong>✨ Unlock lifetime membership</strong>
                </button>
            </div>
        </div>
        <p class="mt-4 text-center">OR</p>
    </section>
</template>

<script>

export default {
    props: {
    },
    data() {
        return {
            code: '',
            errors: {},
        }
    },
    methods: {
        unlock() {
            this.errors = {};
            axios.put('/api/subscription/lifetime', {
                code: this.code,
            })
            .then(response => {
                window.location.reload();
            })
            .catch(errors => {
                this.errors = errors.response.data.errors;
            });
        }
    }
}
</script>